module.exports = require("npm:async.parallel@0.5.2/index.js");